export enum PlRoute {
  creationPassword = 'password/creation',
  friendsSurvey = '360-Survey',
  home = 'home',
  lifeActs = 'my-life-acts-and-module-summary',
  lifeChanges = 'my-life-changes',
  login = 'login',
  profile = 'profile',
  resetPassword = 'password/reset',
  retrieveCredentials = 'retrieve_credentials',
  viaSurvey = 'via-survey',
  maintenanceMode = 'maintenance-in-progress',
}

export const getRoutePath = (route: PlRoute, includeLeadingSlash: boolean = true): string => {
  return `${includeLeadingSlash ? '/' : ''}${route}`;
};
